import { createSlice } from "@reduxjs/toolkit";

interface NewsInitialStateModel {
  filter:any;
}
const NewsInitialState: NewsInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
    SortProperty:"InsertDate",
    SortType:"desc",
    IncludeProperties:["Media"]
  }
};

const newsSlice = createSlice({
  name: "NewsSlice ",
  initialState: NewsInitialState,
  reducers: {
    handleSetNewsFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetNewsFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        SortProperty:"InsertDate",
        SortType:"asc"
      };
    },
   
   
    
  },
});

export const {
  handleSetNewsFilter,
  handleResetNewsFitler,
} = newsSlice.actions;
export default newsSlice;
